var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { isEqual } from 'lodash';
import { TimeSelectorView } from './time-selector';
import { generateMinuteOptions, getNextRoundedTimeParts, getTimePartsFromValue, getValueFromTimeParts, TWELVE_HOURS_OPTIONS, } from './utils';
import config from '../../../../config';
export var TimeSelectorContainer = function (props) {
    var _a = useState(props.value
        ? getNextRoundedTimeParts(props.value, props.valueFormat, props.minInterval)
        : { hour: 8, minute: 0, partOfDay: 'am' }), selectedTime = _a[0], setSelectedTime = _a[1];
    var minuteOptions = generateMinuteOptions(props.minInterval);
    var onTimeChanged = function (key) { return function (newValue) {
        setSelectedTime(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[key] = newValue, _a)));
        });
    }; };
    useEffect(function () {
        props.onValueChange(getValueFromTimeParts(selectedTime, props.valueFormat));
    }, [selectedTime]);
    useEffect(function () {
        if (props.value && !isEqual(getTimePartsFromValue(props.value, props.valueFormat), selectedTime)) {
            setSelectedTime(getNextRoundedTimeParts(props.value, props.valueFormat, props.minInterval));
        }
    }, [props.value]);
    return (_jsx(TimeSelectorView, { hour: selectedTime.hour, onHourChanged: onTimeChanged('hour'), minute: selectedTime.minute, onMinuteChanged: onTimeChanged('minute'), partOfDay: selectedTime.partOfDay, onPartOfDayChanged: onTimeChanged('partOfDay'), hourOptions: TWELVE_HOURS_OPTIONS, minuteOptions: minuteOptions, label: props.label }));
};
TimeSelectorContainer.defaultProps = {
    minInterval: 1,
    value: null,
    label: null,
    valueFormat: config.timeFormat,
};
